var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Profesiones, ocupaciones","audio2":"../mp3/PrimariaF/05PF.mp3","cover":"../img/6.jpg","name":"Primaria F - Lección #5"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }